import { Box, Grid2 as Grid, Paper, Typography } from "@mui/material";
import { PieChart } from '@mui/x-charts/PieChart';
import useScreenSize from '../../../../hooks/useScreenSize';

type SpendProps = {
    spend: number;
    spendByCampaign: { label: string, value: number }[];
    timePeriod: number;
    size?: number;
}

const SpendWidget = ({ spend, spendByCampaign, timePeriod, size = 8 }: SpendProps) => {
    const screenSize = useScreenSize();
    const filteredData = spendByCampaign.sort((c1, c2) => c2.value - c1.value).slice(0, 5);

    return (
        <Grid size={screenSize.width < 1200 ? 12 : size}>
            <Paper elevation={5} sx={{ p: 2 }}>
                <Grid container>
                    <Grid size={4}>
                        <Box display="flex" flexDirection="column" gap={2}>
                            <Typography variant="h6">Overall Spend</Typography>
                            <Typography variant="h4">${spend.toFixed(2)}</Typography>
                            <Typography>
                                Average daily budget over the last {timePeriod} days: ${(spend / timePeriod).toFixed(2)}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid size={8}>
                        <PieChart
                            series={[{ data: filteredData, cx: '35%' }]}
                            height={200}
                            slotProps={{
                                legend: {
                                    padding: 0,
                                    labelStyle: {
                                        fontSize: 14
                                    },
                                    itemMarkWidth: 10,
                                    itemMarkHeight: 10,
                                },
                            }}
                        />
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    )
}

export default SpendWidget;
